module.exports = __webpack_public_path__ + "img/official.78e1c03b.jpg";